import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 点击的订单信息
    projectInfo:{
      projectId:"",
      projectName:"",
      acc:0//是否汇总类型
    },
    // 点击的订单编号
    projectId: "",
    // 当前用户
    currUser: { username: "", token: ""},
    userDept:{p_dept_name:"",s_dept_name:""},
    debugMode:false,
    updateClientList:0,
    todoCount:0,
    clueInfo: "",

    redirect: ""
  },

  mutations: {
    setTodoCount(state,newVal){
      state.todoCount = newVal
      // console.log('state.todoCount',state.todoCount)
    },
    setUpdateClientList(state){
      state.updateClientList += 1
    },
    setUserDept(state,userDept){
      state.userDept = userDept
    },
    setProjectInfo(state,projectInfo){
      state.projectInfo = projectInfo
    },

    setProjectId (state, projectId) {
      state.projectId = projectId;
    },

    setCurrUser (state, currUser) {
      state.currUser = currUser
    },

    setClueInfo(state, clueInfo){
      state.clueInfo = clueInfo
    },

    setRedirect(state, redirect){
      state.redirect = redirect
    }
  },
  actions: {
  },
  modules: {
  }
})
